export default {
  site: {
    separator: ' | ',
    mnbaq: 'MNBAQ',
    resources: 'Ressources pédagogiques', // traduire l'anglais
    mnbaqFull: 'Musée national des beaux-arts du Québec', // traduire l'anglais
  },

  titles: {
    home: 'Page d\'accueil',
    notFound: 'Page introuvable',
  },

  home: {
    title: 'Musée national des beaux-arts du Québec - L\'art dans ma classe',
    inspiration: 'Trouvez l\'inspiration',
    featured: 'En vedette',
    search: {
      explore: 'ou explorez par'
    },
  },

  activities: {
    title: 'Activités',
  },

  artworks: {
    title: 'Œuvres',
  },

  resources: {
    title: 'Ressources',
  },

  search: {
    title: 'Recherche',
  },
  lexique: {
    title: 'Lexique',
  },
  landing: {
    orSearch: 'ou effectuez une recherche',
    favorites: 'Coups de coeur',
    seeAll: {
      activity: 'Voir toutes les activités',
      artwork: 'Voir toutes les œuvres d\'art',
      resource: 'Voir toutes les ressources',
    },
  },

  // Secondary Nav
  mnbaq: {
    title: 'mnbaq.org',
  },
  visit: {
    title: 'Visitez le musée',
  },

  // General
  share: 'Partagez',
  print: 'Imprimez',
  copiedUrl: 'URL copiée!',
  loading: 'Chargement',

  // Activity
  activity: {
    title: 'Activité',
    duration: 'Durée',
    evaluationGrid: 'Grille d\'évaluation',
    inspiredBy: 'Inspiré par',
    isRecommended: 'Activité recommandée!',
    material: 'Matériel',
    otherActivities: {
      title: 'Continuez votre exploration!',
      description: '',
    },
    shareActivity: 'Partagez cette activité',
    steps: 'Étapes de réalisation',
    recommendedCount: 'Recommandé {n} fois',
    recommendThis: 'Recommandez cette activité',
    resourcesHeader: {
      title: 'Pour vous guider!',
      description: 'Ressources en lien avec cette {n}'
    },
    schoolLevel: 'Niveau(x)',
  },

  // Artwork
  artwork: {
    title: 'Œuvre',
    dimensions: 'Dimensions',
    expressionTechniques: 'Technique d\'expression',
    linkedActivities: {
      title: 'À vous de jouer!',
      description: 'Activités en lien avec cette {n}',
      descriptionSingular: 'Activité en lien avec cette {n}',
    },
    otherArtworks: {
      title: 'Parcourez les œuvres d\'art',
      description: '',
    },
    productionDate: 'Date de production',
    resourcesHeader: {
      title: 'Continuez l\'exploration!',
      description: 'Ressources en lien avec cette {n}'
    },
  },

  // Resource
  resource: {
    title: 'Ressource',
  },

  // Cards
  cards: {
    activityCount: {
      singular: '{count} activité',
      plural: '{count} activités',
    },
  },

  // Single: Artwork or activity
  single: {
    about: 'À propos de {n}',
    contentType: {
      activity: 'activité',
      artwork: 'œuvre',
    },
    resources: {
      videos: 'Vidéos',
      files: 'Fichiers téléchargeables',
    },
    suggestions: 'Suggestions',
    suggestionsLinks: 'Liens d\'intérêt',
    suggestionsMedias: 'Suggestions de médias',
  },

  // Not Found (404)
  notFound: {
    returnToHome: 'Retournez à la page d\'accueil',
  },

  // Temp
  formDemo: {
    title: 'Démo',
  },

  uiKit: {
    title: 'UI Kit',
  },

};



// WEBPACK FOOTER //
// ./src/config/locales/fr/pages.js